// extracted by mini-css-extract-plugin
export default {"root":"ArticleInfo_root__-npYg"};